(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSUnidadReceptoraDeleteController',SSUnidadReceptoraDeleteController);

    SSUnidadReceptoraDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSUnidadReceptora'];

    function SSUnidadReceptoraDeleteController($uibModalInstance, entity, SSUnidadReceptora) {
        var vm = this;

        vm.sSUnidadReceptora = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSUnidadReceptora.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
